import { Grid } from "@mui/material";
import { CenterForm } from "../PublicLayout/components/Handle/CenterForm";
import BtnBigWithIcon from "../../components/Button/BtnBigWithIcon/BtnBigWithIcon";
import { ButtonTyppe } from "../../components/Button/Btn";
import { useTranslation } from "react-i18next";
import { ArrowForwardIos, Check } from "@mui/icons-material";
import { KeyDrivePrimaryButton } from "../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveCaption } from "../../components/KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeyDriveBodyMin } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useNavigate, useParams } from "react-router-dom";
import CheckCircleIcon from '../../assets/icons/checkCirclePassword.svg';

export default function PlanCheckout() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <CenterForm 
            icon={CheckCircleIcon} 
            subtitle={t("PlanCheckout.PlanCheckoutContent")}
            title={t("PlanCheckout.PlanCheckoutTitle")}
            titleSize={32} 
        >
            <Grid item xs={12}>
                <Grid container>
                    <KeyDrivePrimaryButton 
                        endIcon={<ArrowForwardIos />}
                        TextComponent={KeyDriveBodyMin}
                        TextComponentProps={{
                            color: "#E8EFF3",
                            needBold: false,
                            needEllipses: false,
                            text: "Retornar para login"
                        }}
                        needFullWidth
                        onClick={()=> {
                            navigate("/login");
                        }}
                    />
                </Grid>
            </Grid>
        </CenterForm>
    )
}